import React from 'react';
import { useNavigate } from 'react-router-dom';

interface HashtagTextProps {
  text: string;
  className?: string;
}

const HashtagText: React.FC<HashtagTextProps> = ({ text, className = '' }) => {
  const navigate = useNavigate();

  const handleHashtagClick = (hashtag: string, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    // Remove the # and navigate to search
    const searchTerm = hashtag.substring(1);
    navigate(`/search?q=${encodeURIComponent('#' + searchTerm)}&tab=posts`);
  };

  // Split text by hashtags and render them as clickable links
  const renderTextWithHashtags = (inputText: string) => {
    // Regex to match hashtags: # followed by word characters (letters, digits, underscore)
    // But not if preceded by a word character (to avoid matching partial words)
    const hashtagRegex = /(?:^|[^#\w])#\w+/g;
    
    // Find all matches with their positions
    const matches = [];
    let match;
    while ((match = hashtagRegex.exec(inputText)) !== null) {
      const fullMatch = match[0];
      const hashtagStart = fullMatch.startsWith('#') ? match.index : match.index + 1;
      const hashtag = fullMatch.startsWith('#') ? fullMatch : fullMatch.substring(1);
      
      matches.push({
        hashtag: hashtag,
        start: hashtagStart,
        end: hashtagStart + hashtag.length
      });
    }

    if (matches.length === 0) {
      return inputText;
    }

    const result = [];
    let lastEnd = 0;

    matches.forEach((match, index) => {
      // Add text before hashtag
      if (match.start > lastEnd) {
        result.push(inputText.substring(lastEnd, match.start));
      }

      // Add clickable hashtag
      result.push(
        <button
          key={`hashtag-${index}`}
          onClick={(e) => handleHashtagClick(match.hashtag, e)}
          className="text-custom-blue-600 hover:text-custom-blue-800 font-medium hover:underline cursor-pointer bg-transparent border-none p-0 inline transition-colors"
        >
          {match.hashtag}
        </button>
      );

      lastEnd = match.end;
    });

    // Add remaining text
    if (lastEnd < inputText.length) {
      result.push(inputText.substring(lastEnd));
    }

    return result;
  };

  return (
    <span className={className}>
      {renderTextWithHashtags(text)}
    </span>
  );
};

export default HashtagText;
